import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { ImageViewer } from 'antd-mobile'
import './css/DetailHeader.css'

export default function DetailHeader(props) {
  const game = props.game
  const startXRef = useRef(null); // 存储触摸起始 X 坐标
  const swiperRef = useRef()
  const imageViewerRef = useRef()
  const innerWidth = window.innerWidth > 720 ? 720 : window.innerWidth;
  const [swiperHeight, setSwiperHeight] = useState(innerWidth * 9 / 16); // 初始高度为16:9比例
  const [activeIndex, setActiveIndex] = useState(0)
  const [data, setData] = useState([])
  const [visible, setVisible] = useState(false)

  const items = game?.game_ur_list.map((img, index) => (
    <SwiperSlide style={{
      width: parseInt(game.five_image_ratio_type) == 1 ? '100%' : '270px',
      height: parseInt(game.five_image_ratio_type) == 1 ? '100%' : '480px',
    }} key={index}>
      <div onClick={() => {
        setVisible(true)
        imageViewerRef.current.swipeTo(index, false)
      }} style={{
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'black',
        width: '100%',
        height: '100%'
      }}>
        <img style={{
          objectFit: 'cover'
        }} src={img} alt="" />
      </div>
    </SwiperSlide>
  ))

  useEffect(() => {
    if (data.length == 0 && game) {
      const newdata = []
      if (game.video_url) {
        newdata.push({
          title: '宣传片',
          direction: parseInt(game.public_video_ratio_type) == 1 ? 'horizontal' : 'vertical',
          type: 'video',
          height: parseInt(game.public_video_ratio_type) == 1 ? innerWidth * 9 / 16 : 480,
          src: game.video_url,
          poster: game.video_img_url,
          event_id:'D-2-25'
        })
      }
      if (game.real_machine_video_url) {
        newdata.push({
          title: '实机演示',
          direction: parseInt(game.real_video_ratio_type) == 1 ? 'horizontal' : 'vertical',
          type: 'video',
          height: parseInt(game.real_video_ratio_type) == 1 ? innerWidth * 9 / 16 : 480,
          src: game.real_machine_video_url,
          poster: game.real_video_img_url,
          event_id:'D-2-26'
        })
      }
      if (game.game_ur_list) {
        newdata.push({
          title: '介绍图',
          direction: parseInt(game.five_image_ratio_type) == 1 ? 'horizontal' : 'vertical',
          type: 'image',
          height: parseInt(game.five_image_ratio_type) == 1 ? innerWidth * 9 / 16 : 480,
          event_id:'D-2-27'
        })
      }
      setData(newdata)
      setSwiperHeight(newdata[0].height)
    }
  }, [data, game])

  useEffect(() => {
    if (props.handleBottom) {
      props.handleBottom(data.length > 0 ? (data[activeIndex].direction === 'vertical' ? -36 : 0) : 0)
    }
  }, [activeIndex, data])

  const handleTouchStart = (swiper, event) => {
    const touch = event.touches ? event.touches[0] : event;
    startXRef.current = touch.clientX; // 记录触摸开始的 X 坐标
  };

  const handleProgress = (swiper, progress) => {
    console.log('progress', progress, swiper.touches);

    if (progress < 0 || progress > 1) return; // 仅在有效范围内处理
    if (startXRef.current === null) return; // 确保有起始坐标

    const currentX = swiper.touches.currentX; // 当前触摸 X 坐标
    const activeIndex = swiper.activeIndex; // 当前激活的滑块索引    
    const targetItem = swiper.slides[activeIndex];
    const targetHeight = data[activeIndex].height;
    let newprogress = 0
    if (data.length == 2) {
      newprogress = progress
    } else if (data.length == 3) {
      newprogress = (progress - (activeIndex / (data.length - 1))) * 2
    }
    if (currentX < startXRef.current) {
      // console.log('左滑', '进度:', progress, '目标 item:', targetItem);
      const nextIndex = activeIndex + 1;
      if (nextIndex < data.length) {
        const nextItem = data[nextIndex];
        const nextHeight = nextItem.height;
        const nextHeightDiff = nextHeight - targetHeight;
        const newHeight = targetHeight + nextHeightDiff * newprogress;
        console.log('左滑newHeight', newHeight);
        setSwiperHeight(newHeight);
      }
    } else if (currentX > startXRef.current) {
      // console.log('右滑', '进度:', progress, '目标 item:', targetItem);
      const beforeIndex = activeIndex - 1;
      if (beforeIndex >= 0) {
        const beforeItem = data[beforeIndex];
        const beforeHeight = beforeItem.height;
        let newHeight = 0
        if (data.length == 2) {
          const beforeHeightDiff = targetHeight - beforeHeight;
          newHeight = beforeHeight + beforeHeightDiff * newprogress;
        } else if (data.length == 3) {
          const beforeHeightDiff = beforeHeight - targetHeight;
          newHeight = targetHeight - beforeHeightDiff * newprogress;
        }
        setSwiperHeight(newHeight);
        console.log('右滑newHeight', newHeight);
      }
    }
  };

  return (
    <div style={{
      paddingTop: 'calc(env(safe-area-inset-top) + 40px)',
      backgroundColor: 'black'
    }}>
      {data.length > 0 && <div>
        <div style={{
          backgroundImage: 'url(resources/250410/game/bg.png)',
          backgroundSize: '100% 100%'
        }}>
          <Swiper
            ref={swiperRef}
            style={{
              height: `${swiperHeight}px`,
            }}
            loop={false}
            spaceBetween={10}
            slidesPerView={'auto'}
            onSlideChange={swiper => {
              setActiveIndex(swiper.activeIndex)
              const video = document.querySelectorAll('video')
              video.forEach(v => {
                v.pause()
              })
            }}
            onTouchStart={handleTouchStart}
            onProgress={handleProgress}>
            {data.map((item, index) => {
              return (
                item.type === 'video' ?
                  <SwiperSlide>
                    <video
                      poster={item.poster}
                      autoPlay={props.autoPlay && index == 0}
                      muted playsInline controls
                      style={{
                        height: `${item.height}px`,
                        marginLeft: '50%',
                        transform: 'translateX(-50%)'
                      }}
                      src={item.src}></video>
                  </SwiperSlide> :
                  <SwiperSlide style={{ backgroundColor: 'black' }}>
                    <Swiper centeredSlides centeredSlidesBounds loop={false} spaceBetween={10} slidesPerView={'auto'}>
                      {items}
                    </Swiper>
                  </SwiperSlide>
              )
            })}
          </Swiper>
          <div style={{
            backgroundColor: 'transparent',
            padding: '10px 0',
            position: 'relative',
            top: data[activeIndex].direction === 'vertical' ? '-35px' : '0',
            zIndex: '2',
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
          }}>
            <div style={{
              display: 'inline-block',
              borderRadius: '8px',
              overflow: 'hidden',
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                borderRadius: '6px',
                backgroundColor: '#1F1F1F',
                padding:'2px'
              }}>
                {
                  data.map((item, index) => (
                    <div style={{
                      color: activeIndex == index ? '#282828' : 'white',
                      backgroundColor: activeIndex == index ? 'white' : '#1F1F1F',
                      borderRadius: activeIndex == index ? '6px' : '0',
                      padding: '0px 7px',
                      fontSize: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignContent: 'center',
                      lineHeight: '12px'
                    }} key={index} onClick={() => {
                      swiperRef.current.swiper.slideTo(index)
                      setActiveIndex(index)
                      setSwiperHeight(data[index].height)
                      Manager.push({ event_id: item.event_id})
                    }}>{item.title}</div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>}
      <ImageViewer.Multi
        classNames={{
          mask: 'game-detail-image-viewer-mask',
          body: 'game-detail-image-viewer-body',
        }}
        ref={imageViewerRef}
        getContainer={() => document.getElementById('root')}
        defaultIndex={0}
        images={game.game_ur_list}
        visible={visible}
        onClose={() => {
          setVisible(false)
        }}
      />
    </div>
  )
}